// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"4f605bf07c5c211e","node_modules_canvg_lib_index_es_js":"e9678ff7966f8cb3"}[chunkId] + ".js";
};